import * as types from '../constants/FeedfilterActionTypes';

export function update_rule(path, update){
	return {
		type: types.UPDATE_RULE,
		path: path,
		update: update
	}
}

export function add_rule(path, scope){
	return {
		type: types.ADD_RULE,
		path: path,
		scope: scope
	}
}

export function add_conjunction(path, type, scope){
	return {
		type: types.ADD_CONJUNCTION,
		path: path,
		conjunction: type,
		scope: scope
	}
}

export function remove_node(path){
	return {
		type: types.REMOVE_NODE,
		path: path
	}
}

export function set_rules(rules){
	return {
		type: types.SET_RULES,
		rules: rules
	}
}
